import { LINKEDIN_PARTNER_ID } from "./tagConfig";
import { CONSENT_CHANGE_EVENT, getConsent, type ConsentState } from "./consent";

declare global {
  interface Window {
    _linkedin_partner_id?: string;
    _linkedin_data_partner_ids?: string[];
  }
}

let injected = false;

const inject = () => {
  if (injected || !LINKEDIN_PARTNER_ID) return;
  injected = true;

  window._linkedin_partner_id = LINKEDIN_PARTNER_ID;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(LINKEDIN_PARTNER_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
  document.head.appendChild(script);
};

/**
 * Loads the LinkedIn Insight Tag, but only once a partner id exists AND
 * marketing consent has been granted. No-ops otherwise.
 */
export const initLinkedInInsight = (): (() => void) => {
  if (!LINKEDIN_PARTNER_ID) return () => undefined;

  if (getConsent()?.marketing) {
    inject();
    return () => undefined;
  }

  const onChange = (e: Event) => {
    const detail = (e as CustomEvent<ConsentState>).detail;
    if (detail?.marketing) inject();
  };

  window.addEventListener(CONSENT_CHANGE_EVENT, onChange);
  return () => window.removeEventListener(CONSENT_CHANGE_EVENT, onChange);
};
